var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "folder_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#folder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.757 15.583c-.366 0-.68-.132-.944-.396a1.288 1.288 0 01-.396-.943V5.756c0-.375.132-.692.396-.95a1.3 1.3 0 01.944-.39h3.507c.178 0 .349.033.513.097.165.064.316.164.452.301l1.603 1.603h6.412c.375 0 .692.13.951.388.26.26.389.576.389.952v6.487c0 .365-.13.68-.389.944-.259.263-.576.395-.951.395H3.757zm0-1.083h12.487a.25.25 0 00.184-.072.25.25 0 00.072-.184V7.757a.25.25 0 00-.072-.185.25.25 0 00-.184-.072h-6.86L7.454 5.572A.233.233 0 007.28 5.5H3.757a.25.25 0 00-.185.072.25.25 0 00-.072.184v8.488a.25.25 0 00.072.184.25.25 0 00.185.072z",
    fill: "#7A8D8F"
  }))));
}
export default SvgFolder;